import publicRouter from './routers/travelRouter';

export default [...publicRouter];
